module.exports = "/_next/static/resources/art-1d9fb183f139392f56dc84616a7c74ab.jpg";